import { MDBIcon, MDBInput } from 'mdbreact';
import React, { Component } from 'react';
import { URLImgFront } from '../../config/URLDB';
import { ConsultarSecciones, ConsultarNiveles, ConsultarEstadoCivil, ConsultarCiudades, InsertHojaVidaDatosBasicos, InsertHojaVidaInfoGeneral, InsertHojaVidaContacto, InsertHojaVidaFormacionAcademica, InsertHojaVidaExperiencia, InsertHojaVidaReferenciaPersonal, ActualizarEstadoHojaVida, EliminarRegistrosFormacionAcademica, EliminarRegistrosExperienciaLaboral, ConsultarExperienciasLaborales, ConsultarAdi, InsertInfoAdicional } from '../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import gsap from 'gsap';
import LottiePlayer from '../Principal/LottiePlayer';
import Select from 'react-select';
import { getCustomSelectStyles } from '../../utils/selectStyles';
import ToggleSwitch from '../Principal/ToggleSwitch';

const generoOptions = [
    { value: 1, label: 'Masculino' },
    { value: 2, label: 'Femenino' },
]

const tipoIdenOptions = [
    { value: 'C', label: 'Cédula de Ciudadanía' },
    { value: 'E', label: 'Cédula de Extranjería' },
    { value: 'PEP', label: 'Permiso Especial de Permanencia' },
    { value: 'PAS', label: 'Pasaporte' }
];

class SeccionCV extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombcargo: props.nombcargo || '',
            idvacante: props.idvacante,
            idsolicitudvacante: 0,
            idexperiencialaboral: 0,
            data: [],
            dataEscolaridad: [],
            dataEstCivil: [],
            pais: null,
            paisContacto: null,
            paisEmpre: null,
            dpto: null,
            dptoContacto: null,
            dptoEmpre1: null,
            mpio: null,
            mpioContacto: null,
            mpioEmpre1: null,
            paises: [],
            dptos: [],
            mpios: [],
            formAcademica: [],
            skills: [],
            sexo: 'DEFAULT',
            tipoiden: 'DEFAULT',
            escolaridad: 'DEFAULT',
            estadoCivil: 'DEFAULT',
            showMobileMenu: false,
            errors: {},
            priNombre: '',
            segNombre: '',
            nit: '',
            nomEmpre: '',
            cargoEmpre1: '',
            cargoEmpre2: '',
            duracionEmpre1: '',
            priApellido: '',
            segApellido: '',
            fecNac: '',
            fecIngEmpre1: '',
            fecRetEmpre1: '',
            telEmpre: '',
            funcEmpre1: '',
            fecExpe: '',
            correo: '',
            mpioLabora: '',
            dirRes: '',
            barrio: '',
            celular: '',
            formAcadem: '',
            hasFormAcadem: false,
            skill: '',
            hadFunciones: false,
            pressedButton: null,
            activeStep: 0, //BY DEFAULT,
            isFinalized: false,
            isSubmitting: false,
            selectedButton: null,
            screenSize: this.getScreenSize(),
            chkTrabaja: false,
            chkTerminos: false,
            chkMpio: false,
            perrefprinom: '',
            perrefsegnom: '',
            perrefpriape: '',
            perrefsegape: '',
            perrefocupa: '',
            perrefempre: '',
            perreftelcel: '',
            isMobile: window.innerWidth < 992,
            experienciasLaborales: [],
            isActual: false,
            dataInfoAdi: [],
            toggleveracidad: false,
            toggleinfoper: false,
            togglegraduado: false,
            anioterminacion: '',
            numsemestre: '',
            descenteraste: '',
            selecinfoadi: 0
        };

        this.inputsRefs = {
            priNombre: React.createRef(),
            segNombre: React.createRef(),
            priApellido: React.createRef(),
            segApellido: React.createRef(),
            nit: React.createRef(),
            fecExpe: React.createRef(),
            correo: React.createRef(),
            fecNac: React.createRef(),
        };

        this.selectRefs = {
            sexo: React.createRef(),
            tipoiden: React.createRef(),
        };

        this.sectionRef = React.createRef();

        this.fechaRetiroEmpleoRef = React.createRef();
        this.tgSwitchEmpleoActualRef = React.createRef();
        this.numSemestreRef = React.createRef();
        this.anioTerminacionRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeStep !== this.state.activeStep) {
            const el = this.sectionRef.current;
            if (el) {
                gsap.fromTo(el,
                    { opacity: 0, scale: 0.9 },
                    { opacity: 1, scale: 1, duration: 0.6, ease: 'power2.out' }
                );
            }

            const currentStepRef = this[`stepRef${this.state.activeStep}`];
            const container = this.barContainerRef;

            if (this.lineRef && currentStepRef && container) {

                const containerRect = container.getBoundingClientRect();
                const stepRect = currentStepRef.getBoundingClientRect();

                const stepCenter = stepRect.left + stepRect.width / 2;
                const offset = stepCenter - containerRect.left;

                gsap.to(this.lineRef, {
                    width: `${offset}px`,
                    duration: 0.6,
                    ease: `power2.out`
                });
            }

            if (this.state.activeStep === 1 && (prevState.dataEscolaridad.length === 0 || prevState.dataEstCivil.length === 0 || prevState.paises.length === 0 || prevState.dataInfoAdi.length === 0)) {
                this.ConsultaEscolaridad();
                this.ConsultarEstCivil();
                this.ConsultaPaises('pais');
                this.ConsultarInfoAdi();
            }

            //Animación botón 'Anterior'
            const btnAnterior = this.btnAnteriorRef;
            if (btnAnterior) {
                if (this.state.activeStep > 0) {
                    gsap.fromTo(btnAnterior,
                        { autoAlpha: 0, x: -40 },
                        { autoAlpha: 1, x: 0, duration: 0.6, ease: 'power2.out' }
                    );
                } else {
                    gsap.to(btnAnterior, { autoAlpha: 0, x: -40, duration: 0.4, ease: 'power2.in' });
                }
            }
            const btnSiguiente = this.btnSiguienteRef;
            if (btnSiguiente) {
                gsap.fromTo(btnSiguiente,
                    { autoAlpha: 0, x: 40 },
                    { autoAlpha: 1, x: 0, duration: 0.6, ease: 'power2.out' }
                );
            }

            const btnSiguienteAlt = this.btnSiguienteAltRef;
            if (btnSiguienteAlt) {
                gsap.fromTo(btnSiguienteAlt,
                    { autoAlpha: 0, x: 40 },
                    { autoAlpha: 1, x: 0, duration: 0.6, ease: 'power2.out' }
                );
            }

            const btnSubmit = this.submitBtnRef;
            if (btnSubmit) {
                gsap.fromTo(btnSubmit,
                    { autoAlpha: 0, x: 40 },
                    { autoAlpha: 1, x: 0, duration: 0.6, ease: 'power2.out' }
                );
            }
        }
    }

    animateIntro = () => {
        const text = this.textRef;
        const plane = this.planeRef;
        const wrapper = this.textContainerRef;

        const tl = gsap.timeline({ paused: false });

        // Fase 1: Mostrar el texto
        tl.fromTo(plane, {
            x: 0,
            rotation: 20,
            y: -10,
        }, {
            x: '204%',
            rotation: -6,
            y: 0,
            duration: 1.2,
            ease: 'power2.inOut'
        }, 0);

        tl.fromTo(text, {
            x: 500,
            rotation: 0
        }, {
            x: 0,
            duration: 1.2,
            ease: 'power2.inOut'
        }, 0);

        tl.fromTo(wrapper, {
            x: '-173'
        }, {
            x: 0,
            duration: 1.2,
            ease: 'power2.inOut'
        }, 0);
    };

    animateSubmit = () => {
        const text = this.textRef;
        const plane = this.planeRef;
        const wrapper = this.textContainerRef;

        const tl2 = gsap.timeline({ paused: true })

        tl2.to(this.barContainerRef, {
            opacity: 0,
            duration: 0,
            ease: 'power1.inOut',
        }, 0)

        .to(this.titleRef, {
            opacity: 0,
            duration: 0.5,
            ease: 'power1.inOut',
        }, 0)

        .to(this.contentRef, {
            opacity: 0,
            duration: 0.5,
            ease: 'power1.inOut',
            onComplete: () => {
                gsap.set([this.barContainerRef, this.titleRef, this.contentRef], { display: 'none' });
                this.setState({ isFinalized: true }, () => {
                    gsap.fromTo(this.finalizedSeccion, {
                        opacity: 0,
                        y: 50,
                    }, {
                        opacity: 1,
                        y: 0,
                        duration: 0.5,
                        ease: 'power2.out',
                    });
                });
            }
        }, 0)

        const tl = gsap.timeline({
            paused: false,
            onComplete: () => {
                tl2.play();
            }
        });

        tl.add('startPhase2', '+=0.6');

        // Inicio fase 2
        tl.to(text, {
            x: 500,
            duration: 1.2,
            ease: 'power2.inOut',
        }, 'startPhase2');

        tl.to(wrapper, {
            x: -173,
            duration: 1.2,
            ease: 'power2.inOut',
        }, 'startPhase2');

        tl.to(this.lineRef, {
            width: '100%',
            duration: 0.6,
            ease: 'power2.out'
        }, 'startPhase2');

        tl.to(this.dotEndRef, {
            backgroundColor: '#f57c00',
            delay: 0.4,
            scale: 1.2,
            duration: 0.4,
            ease: 'power2.out'
        }, 'startPhase2');

        tl.to(this.dotStartRef, {
            scale: 1.2,
            delay: 0.4,
            duration: 0.4,
            ease: 'power2.out'
        }, 'startPhase2');

        // Movimiento del avión
        tl.fromTo(plane,
            {
                x: '204%',
                rotation: -6,
                y: 0
            },
            {
                x: 0,
                rotation: 20,
                y: -10,
                duration: 1.2,
                ease: 'power2.inOut',
            },
            'startPhase2'
        );

        tl.to(plane, {
            x: "+=10",
            y: "-=6",
            rotation: 8,
            duration: 0.5,
            ease: 'sine.inOut'
        });

        tl.to(plane, {
            x: "+=250",
            y: "-=145",
            rotation: 9,
            duration: 0.3,
            ease: 'sine.inOut'
        });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.fetchData();
        window.addEventListener('resize', this.handleResize);
        this.animateIntro();
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const isMobile = window.innerWidth < 992;
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile });
        }
    };

    fetchData = () => {
        const params = {
            tran: 5,
            estado: 1
        }

        return ConsultarSecciones(params).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data[0].message === "004404") {
                        Swal.fire({
                            icon: 'error',
                            title: 'No se encontró información de las secciones'
                        })
                    }
                    else {
                        this.setState({
                            data: response.data
                        })
                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    })
                }
            }
            catch (error) {
                this.setState({ error: error.toString() });
            }
        });
    }

    ConsultaEscolaridad = () => {
        return ConsultarNiveles().then(response => {
            try {
                const { data } = response;
                if (data.length > 0 && data[0].message !== "004404") {

                    const escolaridadOptions = data.map(item => ({
                        value: item.codescol,
                        label: item.desescol
                    }));
                    this.setState({ dataEscolaridad: escolaridadOptions });

                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: data[0]?.message === "004404"
                            ? 'No se encontró información de los niveles de escolaridad!'
                            : 'Ocurrio un error!'
                    });
                }
            }
            catch (error) {
                this.setState({ error: error.toString() });
            }
        })
    }

    ConsultarInfoAdi = () => {
        return ConsultarAdi().then(response => {
            try {
                const { data } = response;
                if (data.length > 0 && data[0].message !== "004404") {

                    const infoadiOptions = data.map(item => ({
                        value: item.codenteraste,
                        label: item.descenteraste
                    }));
                    this.setState({ dataInfoAdi: infoadiOptions });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: data[0]?.message === "004404"
                            ? 'No se encontró información de las opciones de como enterarse!'
                            : 'Ocurrio un error!'
                    });
                }
            }
            catch (error) {
                this.setState({ error: error.toString() });
            }
        })
    }

    ConsultarEstCivil = () => {
        return ConsultarEstadoCivil().then(response => {
            try {
                const { data } = response;

                if (data.length > 0 && data[0].message !== "004404") {

                    const estadoCivilOptions = data.map(item => ({
                        value: item.estciv,
                        label: item.desest
                    }));

                    this.setState({ dataEstCivil: estadoCivilOptions });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: data[0]?.message === "004404"
                            ? 'No se encontró información de Estado Civil!'
                            : 'Ocurrio un error EST!'
                    })
                }
            }
            catch (error) {
                this.setState({ error: error.toString() });
            }
        })
    }

    ConsultaPaises = (name, parentValue = '') => {
        let tran = 6;
        let idPais = '';
        let idDpto = '';
        let idMpio = '';

        switch (name) {
            case 'dpto':
            case 'dptoContacto':
            case 'dptoEmpre1':
                idPais = parentValue;
                break;
            case 'mpio':
            case 'mpioContacto':
            case 'mpioEmpre1':
                idPais =
                    name === 'mpioContacto'
                        ? this.state.paisContacto.value
                        : name === 'mpioEmpre1'
                            ? this.state.paisEmpre
                            : this.state.pais.value;
                idDpto = parentValue;
                break;
            default:
                idPais = '';
        }

        const data = { tran, idPais, idDpto, idMpio };

        return ConsultarCiudades(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data[0].message === "004404") {
                        Swal.fire({
                            icon: 'error',
                            title: 'No se encontró información en la consulta'
                        });
                    } else {
                        let opciones = null;

                        switch (name) {
                            case 'pais':
                            case 'paisContacto':
                            case 'paisEmpre':
                                opciones = response.data.map(item => ({
                                    label: item.nombrepais,
                                    value: item.idpais
                                }))
                                break;

                            case 'dpto':
                            case 'dptoContacto':
                            case 'dptoEmpre1':
                                opciones = response.data.map(item => ({
                                    label: item.nombredpto,
                                    value: item.iddepartamento
                                }))
                                break;

                            case 'mpio':
                            case 'mpioContacto':
                            case 'mpioEmpre1':
                                opciones = response.data.map(item => ({
                                    label: item.nombrempio,
                                    value: item.idmunicipio
                                }))
                                break;
                            default:
                                break;
                        }
                        switch (name) {
                            case 'pais':
                            case 'paisContacto':
                            case 'paisEmpre':
                                name = 'paise';
                                break;

                            case 'dptoContacto':
                            case 'dptoEmpre1':
                                name = 'dpto';
                                break;

                            case 'mpioContacto':
                            case 'mpioEmpre1':
                                name = 'mpio';
                                break;
                            default:
                        }

                        this.setState({
                            [`${name}s`]: opciones
                        });
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrió un error!'
                    });
                }
            } catch (error) {
                // handle error
            }
        });
    };


    textInput = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        //NO PERMITE VALORES NUMERICOS
        if (name === 'priNombre' || name === 'priApellido' || name === 'segNombre' || name === 'segApellido' || name === 'perrefprinom' || name === 'perrefsegnom' || name === 'perrefpriape' || name === 'perrefsegape' || name === 'perrefempre') {
            newValue = value.replace(/[0-9]/g, '');
        }
        //NO PERMITE CARACTERES
        if (name === 'celular' || name === 'telEmpre' || name === 'perreftelcel' || name === 'anioterminacion') {
            newValue = value.replace(/\D/g, '').slice(0, 10);
        }
        //SOLO PERMITE LETRAS, ESPACIOS, TILDES, PUNTOS, Ñ Y PARÉNTESIS
        if (name === 'formAcadem' || name === 'funcEmpre1') {
            newValue = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s(),.]/g, '');
        }
        if (name === 'barrio') {
            newValue = value.replace(/[^0-9a-zA-ZáéíóúÁÉÍÓÚñÑ\s(),.:;-]/g, '');
        }
        //NO PERMITE SÍMBOLOS 
        if (name === 'nit') {
            if (this.state.tipoiden === 'PAS') {
                newValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            } else { //NI LETRAS
                newValue = value.replace(/[^0-9]/g, '');
            }
        }
        if (name === 'correo') {
            newValue = value.replace(/[^0-9a-zA-ZáéíóúÁÉÍÓÚñÑ\s@+_.-]/g, '').replace(/[\s,]/g, "").replace(/\.{2,}/g, ".").replace(/_{2,}/g, "_").replace(/-{2,}/g, "-");
        }

        this.setState({ [name]: newValue }, () => {
            const { fecIngEmpre1, fecRetEmpre1 } = this.state;

            if (fecIngEmpre1 && fecRetEmpre1) {
                const fechaIngreso = new Date(fecIngEmpre1);
                const fechaRetiro = new Date(fecRetEmpre1);

                if (fechaIngreso <= fechaRetiro) {
                    const tenure = this.tenureCalculation(fecIngEmpre1, fecRetEmpre1);
                    this.setState({ duracionEmpre1: tenure });
                } else {
                    this.setState({ duracionEmpre1: '' });
                }
            } else {
                this.setState({ duracionEmpre1: '' });
            }
        });

    };

    //helpers
    isValidNumber = (number) => {
        number = number.trim();
        return /^(3\d{9}|60\d8\d{6})$/.test(number);
    }

    isValidAnio = (anio) => {
        anio = anio.trim();
        return /^(19\d{2}|20\d{2})$/.test(anio);
    }

    isValidSemes = (semes) => {
        semes = semes.trim();
        return /^([1-9]|1[0-5])$/.test(semes);
    }

    isValidEmail = (email) => {
        email = email.trim();
        return /^[a-zA-ZÁÉÍÓÚÑáéíóúñ0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    }

    isNumeric = (val) => /^\d+$/.test(val);

    isValidName = (val) => /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s]+$/.test(val);

    validateMinLenght = (value, fieldName, minLenght = 8) => {
        const e = {};
        const fieldValue = (value || '').trim();

        if (fieldValue !== "" && fieldValue.length < minLenght) {
            e[fieldName] = `Escribe mínimo ${minLenght} caracteres para añadir un item.`
        }
        return e;
    }

    //Mapa para validación por step
    validators = {
        //Seccion 0
        0: () => {
            const e = {};
            const s = this.state;

            if (!s.priNombre || s.priNombre.trim().length < 2) e.priNombre = 'Ingresa un primer nombre válido (min. 2 caracteres)';
            if (!s.priApellido || s.priApellido.trim().length < 2) e.priApellido = 'Ingresa un apellido válido';
            if (!s.sexo || s.sexo === 'DEFAULT') e.sexo = 'Selecciona una opción';
            if (!s.tipoiden || s.tipoiden === 'DEFAULT') e.tipoiden = 'Selecciona un tipo de documento';
            if (!s.nit || String(s.nit).trim().length < 6) e.nit = 'Ingresa el documento correctamente';
            if (!s.fecExpe) {
                e.fecExpe = 'Ingresa una fecha de expedición';
            } else {
                const fecIngresada = new Date(s.fecExpe);
                fecIngresada.setHours(0, 0, 0, 0);
                const fecActual = new Date();
                fecActual.setHours(0, 0, 0, 0);
                if (fecIngresada > fecActual) e.fecExpe = 'La fecha de expedición no puede ser futura';
                if (s.fecNac) {
                    const fecNacimiento = new Date(s.fecNac);
                    fecNacimiento.setHours(0, 0, 0, 0);
                    if (fecIngresada < fecNacimiento) {
                        e.fecExpe = 'Fecha de expedición no puede ser menor a la de nacimiento';
                    }
                }
            };

            if (!s.correo) {
                e.correo = 'Ingresa tu correo';
            } else {
                if (!this.isValidEmail(s.correo)) {
                    e.correo = 'El correo no es válido';
                }
            }
            if (!s.fecNac) {
                e.fecNac = 'Ingresa fecha de nacimiento';
            } else {
                const fecIngresada = new Date(s.fecNac);
                fecIngresada.setHours(0, 0, 0, 0);
                const fecActual = new Date();
                fecActual.setHours(0, 0, 0, 0);
                if (fecIngresada > fecActual) {
                    e.fecNac = 'La fecha de nacimiento no puede ser futura';
                } else {
                    //edad
                    let edad = fecActual.getFullYear() - fecIngresada.getFullYear();
                    const mes = fecActual.getMonth() - fecIngresada.getMonth();
                    if (mes < 0 || (mes === 0 && fecActual.getDate() < fecIngresada.getDate())) {
                        edad--;
                    }

                    if (edad < 18) {
                        e.fecNac = 'Debes ser mayor o igual a 18 años';
                    }
                }
            }
            return e;
        },
        //Seccion 1
        1: () => {
            const e = {};
            const s = this.state;

            if (!s.escolaridad || s.escolaridad === 'DEFAULT') e.escolaridad = 'Selecciona el nivel de escolaridad';
            if (!s.estadoCivil || s.estadoCivil === 'DEFAULT') e.estadoCivil = 'Elige tu estado civil';
            if (!s.pais || s.pais === 'DEFAULT') e.pais = 'Selecciona un país';
            if (!s.dpto || s.dpto === 'DEFAULT') e.dpto = 'Selecciona el departamento)';
            if (!s.mpio || s.mpio === 'DEFAULT') e.mpio = 'Elige tu ciudad de nacimiento';

            return e;
        },
        //Seccion 2
        2: () => {
            const e = {};
            const s = this.state;

            const dir = (s.dirRes || '').trim();

            if (!dir) {
                e.dirRes = 'Ingresa tu dirección de residencia';
            } else if (dir.length < 5) {
                e.dirRes = 'La dirección es demasiado corta (mín. 5 caracteres)';
            } else if (dir.length > 150) {
                e.dirRes = 'La dirección es demasiado larga';
            } else {
                const addressRegex = /^[A-Za-z0-9À-ÿ#\-\s\.,ºª()\/]+$/u;
                if (!addressRegex.test(dir)) e.dirRes = 'La dirección contiene caracteres inválidos';
            }
            const barrio = (s.barrio || '').trim();
            if (!barrio) {
                e.barrio = 'Ingresa el nombre del barrio';
            } else if (barrio.length < 2) {
                e.barrio = 'El nombre del barrio es demasiado corto';
            }
            if (!s.paisContacto) e.paisContacto = 'Selecciona tu país de residencia';
            if (!s.dptoContacto) e.dptoContacto = 'Selecciona un departamento';
            if (!s.mpioContacto) e.mpioContacto = 'Selecciona una ciudad';

            if (s.chkMpio) {
                const mpioLab = (s.mpioLabora || '').trim();
                if (!mpioLab) e.mpioLabora = 'Indica el municipio donde puedes laborar';
                else if (mpioLab.length < 3) e.mpioLabora = 'Nombre de municipio demasiado corto';
            }

            const cel = (s.celular || '').trim();
            if (!cel) {
                e.celular = 'Ingresa el número de teléfono';
            } else {
                if (!this.isValidNumber(cel)) e.celular = 'El número debe tener 10 dígitos, empezando con 3 o el formato fijo';
            }

            return e;
        },

        //Seccion 3
        /*AJUSTE PARA RQTO HOJA DE VIDA PAGINA WEB JUANPAGM - 2025/00/00*/
        3: () => {
            return this.validateMinLenght(this.state.formAcadem, "formAcadem", 4);
        },
        /*FIN*/

        //Seccion 4
        4: () => {
            const e = {};
            const s = this.state;

            const campos = [
                s.nomEmpre, s.telEmpre, s.paisEmpre, s.dptoEmpre1, s.mpioEmpre1,
                s.cargoEmpre1, s.fecIngEmpre1, s.fecRetEmpre1, s.duracionEmpre1, s.funcEmpre1, s.skills
            ];

            const algunCampoLleno = campos.some(c => c && String(c).trim() !== "");

            if (algunCampoLleno) {
                if (!s.nomEmpre || s.nomEmpre.trim().length < 2)
                    e.nomEmpre = "Ingresa un nombre de empresa válido (mín. 2 caracteres)";
                if (!s.telEmpre) {
                    e.telEmpre = "Ingresa el número de teléfono";
                } else if (!this.isValidNumber(s.telEmpre)) {
                    e.telEmpre = "El número debe tener 10 dígitos, empezando con 3 o el formato fijo";
                }
                if (!s.paisEmpre) e.paisEmpre = "Selecciona un país";
                if (!s.dptoEmpre1) e.dptoEmpre1 = "Selecciona un departamento";
                if (!s.mpioEmpre1) e.mpioEmpre1 = "Selecciona una ciudad";
                if (!s.cargoEmpre1 || s.cargoEmpre1.trim().length < 2)
                    e.cargoEmpre1 = "Ingresa el cargo (mín. 2 caracteres)";
                if (!s.fecIngEmpre1) {
                    e.fecIngEmpre1 = "Ingresa la fecha de ingreso";
                }
                if (!s.fecRetEmpre1) {
                    e.fecRetEmpre1 = "Ingresa la fecha de retiro";
                }
                if (s.fecIngEmpre1 && s.fecRetEmpre1) {
                    const inicio = new Date(s.fecIngEmpre1);
                    const retiro = new Date(s.fecRetEmpre1);
                    if (retiro < inicio) {
                        e.fecRetEmpre1 = "La fecha de retiro no puede ser anterior a la de ingreso";
                    }
                }
                if (!s.duracionEmpre1 || s.duracionEmpre1.trim() === "")
                    e.duracionEmpre1 = "Ingresa la duración del empleo";
                if ((!s.skills || s.skills.length < 5)) {
                    if (!s.funcEmpre1 || s.funcEmpre1.trim().length < 5) {
                        e.funcEmpre1 = "Ingresa al menos una función válida (mín. 5 caracteres)";
                    }
                    e.skills = "Agrega 5 funciones principales";
                }
            }

            return e;
        },
        //Seccion 5
        5: () => {
            const e = {};
            const s = this.state;

            if (!s.perrefprinom || s.perrefprinom.trim() === "") {
                e.perrefprinom = "El primer nombre es obligatorio.";
            } else if (!this.isValidName(s.perrefprinom)) {
                e.perrefprinom = "El nombre solo puede contener letras.";
            }
            if (s.perrefsegnom && !this.isValidName(s.perrefsegnom)) {
                e.perrefsegnom = "El segundo nombre solo puede contener letras.";
            }
            if (!s.perrefpriape || s.perrefpriape.trim() === "") {
                e.perrefpriape = "El primer apellido es obligatorio.";
            } else if (!this.isValidName(s.perrefpriape)) {
                e.perrefpriape = "El apellido solo puede contener letras.";
            }
            if (s.perrefsegape && !this.isValidName(s.perrefsegape)) {
                e.perrefsegape = "El segundo apellido solo puede contener letras.";
            }
            if (!s.perrefempre || s.perrefempre.trim() === "") {
                e.perrefempre = "El nombre de la empresa es obligatorio.";
            }
            if (!s.perreftelcel || s.perreftelcel.trim() === "") {
                e.perreftelcel = "El número de contacto es obligatorio.";
            } else if (!this.isValidNumber(s.perreftelcel)) {
                e.perreftelcel = "El número debe tener 10 dígitos, empezando con 3 o el formato fijo";
            }
            if (!s.perrefocupa || s.perrefocupa.trim() === "") {
                e.perrefocupa = "La ocupación es obligatoria.";
            } else if (!this.isValidName(s.perrefocupa)) {
                e.perrefocupa = "La ocupación solo puede contener letras.";
            }
            return e;
        },
        //Seccion 6
        6: () => {
            const e = {};
            const s = this.state;
            if (s.selecinfoadi === 5 && s.descenteraste.trim() === "") {
                e.descenteraste = "Debe agregar una descripcion.";
            }
            if (!s.toggleveracidad) {
                e.toggleveracidad = "Debes aceptar la veracidad de los datos."
            }
            if (!s.chkTerminos) {
                e.chkTerminos = "Debes aceptar la pólítica de tratamiento de datos personales para avanzar."
            }
            return e
        }
    };

    handleCheckBox = (checkBox, toClear) => {
        this.setState((prevState) => {
            const newChecked = !prevState[checkBox];
            return {
                [checkBox]: newChecked,
                [toClear]: newChecked ? prevState[toClear] : ""
            };
        });
    };

    validateSection = (step) => {
        const validatePorSeccion = this.validators[step];
        const errors = validatePorSeccion ? validatePorSeccion() : {};
        this.setState({ errors });
        if (Object.keys(errors).length > 0) {
            this.focusFirstError(errors); //Bloquea con false en el handleNext
            return false;
        }
        return true; //Si no hay errores avance
    }

    focusFirstError = (errors) => {
        const firstField = Object.keys(errors)[0]; //Primer campo con error
        if (!firstField) return;

        //Enfoque de react-select
        const selRef = this.selectRefs[firstField];
        if (selRef && typeof selRef.focus === 'function') {
            selRef.focus();
            return;
        }

        const inpRef = this.inputsRefs[firstField];
        if (inpRef && inpRef.focus) {
            inpRef.focus();
            return;
        }

        const el = document.querySelector(`[name="${firstField}"]`);
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    };

    getScreenSize = () => {
        const width = window.innerWidth;
        if (width <= 768) return 'xs';
        return 'lg';
    }

    getMobileDesktopCssClass(screenSize) {
        if (screenSize === 'xs') return 'container-fluid';
        return 'row';
    }

    getMobileDesktopStyle(screenSize) {
        if (screenSize < 768) {
            return {
                flexDirection: 'column',
                justifyContent: 'space-around',
                gap: '5px',
                margin: 'auto'
            };
        }

        return {
            flexDirection: 'row',
            justifyContent: 'space-around',
            gap: '5px',
            margin: 'auto'
        };
    }
    onBTNMouseEnter = e => {
        const btn = e.currentTarget;
        const bubble = btn.querySelector('.hover-bubble');

        // crece la burbuja
        gsap.to(bubble, {
            scale: 1,
            duration: 0.4,
            ease: 'power2.out'
        });
    }

    onBTNMouseMove = e => {
        const btn = e.currentTarget;
        const bubble = btn.querySelector('.hover-bubble');

        const x = e.nativeEvent.offsetX;
        const y = e.nativeEvent.offsetY;

        gsap.set(bubble, {
            x: x,
            y: y
        });
    }

    onBTNMouseLeave = e => {
        const btn = e.currentTarget;
        const bubble = btn.querySelector('.hover-bubble');
        const text = btn.querySelector('.btn-text');
        // retrae la burbuja
        gsap.to(bubble, {
            scale: 0,
            duration: 0.4,
            ease: 'power2.in'
        });
        // revierte el texto a blanco
        gsap.to(text, {
            color: '#fff',
            duration: 0.3
        });
    }

    cleanExperiencia = () => {
        if (this.state.isActual && this.tgSwitchEmpleoActualRef.current) {
            this.tgSwitchEmpleoActualRef.current.toggle();
        }

        this.setState({
            idexperiencialaboral: 0,
            nomEmpre: '',
            telEmpre: '',
            paisEmpre: null,
            dptoEmpre1: null,
            mpioEmpre1: null,
            cargoEmpre1: '',
            fecIngEmpre1: '',
            fecRetEmpre1: '',
            duracionEmpre1: '',
            funcEmpre1: '',
            skills: []
        });
    }

    handleAddExperiencia = () => {
        if (!this.validateSection(4)) return;
        this.addExperienciaLaboral().then(res => {
            if (res === "000000") {
                this.cleanExperiencia();
            }
        });
    }

    isEmptyExperiencia = () => {
        const s = this.state;

        return !(
            (s.nomEmpre && String(s.nomEmpre).trim()) ||
            (s.telEmpre && String(s.telEmpre).trim()) ||
            (s.paisEmpre && s.paisEmpre.value) ||
            (s.dptoEmpre1 && s.dptoEmpre1.value) ||
            (s.mpioEmpre1 && s.mpioEmpre1.value) ||
            (s.cargoEmpre1 && String(s.cargoEmpre1).trim()) ||
            s.fecIngEmpre1 ||
            s.fecRetEmpre1 ||
            (s.duracionEmpre1 && String(s.duracionEmpre1).trim()) ||
            s.funcEmpre1 ||
            (s.skills && s.skills.length > 0)
        );
    };

    fetchExperiencias = () => {
        const data = {
            tran: 5,
            idsolicitudvacante: this.state.idsolicitudvacante
        };
        return ConsultarExperienciasLaborales(data).then(res => {
            if (res && res.length > 0 && res[0].message !== "004404") {
                this.setState({ experienciasLaborales: res });
            } else {
                this.setState({ experienciasLaborales: [] });
            }
        }).catch(err => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Ocurrió un error consultando las experiencias laborales.' });
        });
    }

    handleEliminarExperiencia = (idexperiencialaboral) => {
        const deleteBody = {
            idexperiencialaboral: idexperiencialaboral,
            idsolicitudvacante: this.state.idsolicitudvacante,
        };
        return EliminarRegistrosExperienciaLaboral(deleteBody).then(result => {
            if (result[0].code === "000000") {
                this.fetchExperiencias();
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar la Experiencia laboral.' });
            }
        }).catch(() => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar la Experiencia laboral.' });
        });
    }

    addExperienciaLaboral = () => {
        const { activeStep } = this.state;
        //if (!this.validateSection(activeStep)) return;
        const s = this.state;

        const funciones = (s.skills || []).map((funcion, index) => ({
            idfuncion: index + 1,
            funcionprin: String(funcion).trim().toUpperCase()
        }));

        const funcionesJSON = funciones.length > 0 ? JSON.stringify(funciones) : null;

        const body = {
            tran: 1,
            idexperiencialaboral: s.idexperiencialaboral,
            idsolicitudvacante: s.idsolicitudvacante,
            nomempresa: String(s.nomEmpre).trim().toUpperCase() || null,
            telefono: String(s.telEmpre).trim() || null,
            idpais: s.paisEmpre ? s.paisEmpre.value : null,
            iddpto: s.dptoEmpre1 ? s.dptoEmpre1.value : null,
            idciudad: s.mpioEmpre1 ? s.mpioEmpre1.value : null,
            cargo: String(s.cargoEmpre1).trim().toUpperCase() || null,
            fecingreso: s.fecIngEmpre1 || null,
            fecretiro: s.fecRetEmpre1 || null,
            duracion: s.duracionEmpre1.trim().toUpperCase() || null,
            funciones: funcionesJSON,
            empresaact: s.isActual ? 1 : 0
        };

        const isEmptyExperiencia = !body.nomempresa &&
            !body.telefono &&
            !body.idpais &&
            !body.iddpto &&
            !body.idciudad &&
            !body.cargo &&
            !body.fecingreso &&
            !body.fecretiro &&
            !body.duracion &&
            !body.funciones;

        if (isEmptyExperiencia) {
            if (s.hadFunciones) {
                const deleteBody = {
                    idexperiencialaboral: s.idexperiencialaboral,
                    idsolicitudvacante: s.idsolicitudvacante,
                };
                return EliminarRegistrosExperienciaLaboral(deleteBody).then(result => {
                    if (result[0].code === "000000") {
                        this.setState({ idexperiencialaboral: 0, hadFunciones: false });
                        this.cleanExperiencia();
                        this.fetchExperiencias();

                    } else {
                        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar la Experiencia laboral, no puedes avanzar.' });
                    }
                }).catch(() => {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar la Experiencia laboral, no puedes avanzar.' });
                });
            }
            this.setState({ activeStep: activeStep + 1 });
            return Promise.resolve("000000"); //Pasa directo si estaba vacío
        } else {
            //console.log("Data de experiencia:", body);
            return InsertHojaVidaExperiencia(body).then(result => {
                if (result[0].code === "000000") {
                    this.fetchExperiencias();
                    this.cleanExperiencia();
                    return result[0].code;
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la Experiencia laboral, no puedes avanzar.' });
                }

            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la sección de Experiencia laboral.' });
            });
        }
    }

    handleNext = () => {
        const { activeStep } = this.state;
        if (!this.validateSection(activeStep)) return;

        if (activeStep === 0) {
            const body = {
                tran: 1,
                idsolicitudvacante: parseInt(this.state.idsolicitudvacante),
                prinom: this.state.priNombre.toUpperCase().trim(),
                segnom: this.state.segNombre.toUpperCase().trim(),
                priape: this.state.priApellido.toUpperCase().trim(),
                segape: this.state.segApellido.toUpperCase().trim(),
                genero: parseInt(this.state.sexo),
                fecnaco: this.state.fecNac,
                tipoiden: this.state.tipoiden,
                nit: this.state.nit.trim(),
                fecexpe: this.state.fecExpe,
                correo: this.state.correo.toUpperCase().trim(),
                estadosoli: 1
            };

            InsertHojaVidaDatosBasicos(body).then(result => {
                if (result[0].code === "000000") {
                    this.setState({
                        idsolicitudvacante: parseInt(result[0].idSol),
                        activeStep: activeStep + 1
                    });
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudieron enviar los Datos Básicos, no puedes avanzar.' });
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la información básica.' });
            });
        }

        if (activeStep === 1) {
            const body = {
                tran: 1,
                idsolicitudvacante: parseInt(this.state.idsolicitudvacante),
                codescol: this.state.escolaridad,
                idvacante: this.state.idvacante,
                estciv: this.state.estadoCivil,
                idpaisnaco: parseInt(this.state.pais.value),
                iddtponaco: parseInt(this.state.dpto.value),
                idciudadnaco: parseInt(this.state.mpio.value),
                trabajoconnosotros: this.state.chkTrabaja ? 1 : 0,
                tienevehiculo: this.state.toggleinfoper ? 1 : 0
            };
            
            InsertHojaVidaInfoGeneral(body).then(result => {
                if (result[0].code === "000000") {
                    this.setState({ activeStep: activeStep + 1 });
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la Información General, no puedes avanzar.' });
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la información general.' });
            });
        }


        if (activeStep === 2) {
            const body = {
                tran: 1,
                idsolicitudvacante: this.state.idsolicitudvacante,
                idpaisreside: this.state.paisContacto.value,
                iddptoreside: this.state.dptoContacto.value,
                idciudadreside: this.state.mpioContacto.value,
                dirres: this.state.dirRes.trim().toUpperCase(),
                disponiotrompio: this.state.mpioLabora ? this.state.mpioLabora.trim().toUpperCase() : "",
                barrio: this.state.barrio.trim().toUpperCase(),
                telcel: this.state.celular.trim()
            };
            InsertHojaVidaContacto(body).then(result => {
                if (result[0].code === "000000") {
                    this.setState({ activeStep: activeStep + 1 });
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la Información de Contacto, no puedes avanzar.' });
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la sección de contacto.' });
            });
        }
        //NOTA: VER POSIBILIDAD DE HACER USO DE FUNCIONES ASINCRÓNICAS PARA NO REPETIR CÓDGIO.
        if (activeStep === 3) {
            const isEmptyFormacion = this.state.formAcademica.length === 0;

            if (isEmptyFormacion) {
                if (this.state.hasFormAcadem) {
                    const deleteBody = { tran: 3, idsolicitudvacante: this.state.idsolicitudvacante, idformacion: 0, graduado: 0, anioterminacion: '', numsemestre: 0 };
                    EliminarRegistrosFormacionAcademica(deleteBody).then(result => {
                        const data = result.data;
                        if (data[0].code === "000000") {
                            this.setState({ activeStep: activeStep + 1, hasFormAcadem: false });
                        } else {
                            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudieron eliminar los registros de Formación Académica, no puedes avanzar.' });
                        }
                    }).catch(err => {
                        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo procesar la eliminación de los registros de Formación Académica, no puedes avanzar.' });
                    });
                } else {
                    this.setState({ activeStep: activeStep + 1 });
                }
            } else {
                const deleteBody = { tran: 3, idsolicitudvacante: this.state.idsolicitudvacante, idformacion: 0, graduado: 0, anioterminacion: '', numsemestre: 0 };
                EliminarRegistrosFormacionAcademica(deleteBody).then(result => {
                    const data = result.data;
                    if (data[0].code === "000000") {
                        const requests = this.state.formAcademica.map((item, index) => {
                            const body = {
                                tran: 1,
                                idsolicitudvacante: this.state.idsolicitudvacante,
                                idformacion: index + 1,
                                formacion: item.formacion,
                                graduado: item.graduado,
                                anioterminacion: item.anioterminacion,
                                numsemestre: item.numsemestre
                            };
                            return InsertHojaVidaFormacionAcademica(body);
                        });
                        
                        Promise.all(requests)
                            .then(responses => {
                                const allOk = responses.every(res => res[0]?.code === "000000");
                                if (allOk) {
                                    this.setState({ activeStep: activeStep + 1, hasFormAcadem: true });
                                } else {
                                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudieron enviar todas las formaciones académicas, no puedes avanzar.' });
                                }
                            })
                            .catch(err => {
                                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la sección de formación académica.' });
                            });
                    } else {
                        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudieron eliminar los registros de Formación Académica, no puedes avanzar.' });
                    }
                }).catch(err => {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo procesar la eliminación de los registros de Formación Académica, no puedes avanzar.' });
                });   
            }

            const inputAnioRef = this.anioTerminacionRef?.current;
            const inputSemesRef = this.numSemestreRef?.current;
            if (inputSemesRef) gsap.set(inputSemesRef, { pointerEvents: 'auto', opacity: 1 });
            if (inputAnioRef) gsap.set(inputAnioRef, { pointerEvents: 'auto', opacity: 1 });
        }
        
        if (activeStep === 4) {
            if (this.state.experienciasLaborales.length < 2) {
                this.addExperienciaLaboral();
            }
            if (this.state.experienciasLaborales.length >= 2) {
                this.addExperienciaLaboral().then(code => {
                    if (code === "000000") this.setState({ activeStep: activeStep + 1 });
                });
            }
        }

        if (activeStep === 5) {
            const body = {
                tran: 1,
                idsolicitudvacante: this.state.idsolicitudvacante,
                prinom: this.state.perrefprinom.trim().toUpperCase(),
                segnom: this.state.perrefsegnom.trim().toUpperCase(),
                priape: this.state.perrefpriape.trim().toUpperCase(),
                segape: this.state.perrefsegape.trim().toUpperCase(),
                ocupacion: this.state.perrefocupa.trim().toUpperCase(),
                empresa: this.state.perrefempre.trim().toUpperCase(),
                telcel: this.state.perreftelcel.trim()
            };
            InsertHojaVidaReferenciaPersonal(body).then(result => {
                if (result[0].code === "000000") {
                    this.setState({ activeStep: activeStep + 1 });
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la Referencia personal, no puedes avanzar.' });
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la sección de referencia.' });
            });
        }
    };

    handleBack = () => {
        this.setState(({ activeStep }) => ({
            activeStep: Math.max(activeStep - 1, 0)
        }));
    };

    handleSubmit = () => {
        const { activeStep } = this.state;
        if (this.state.isSubmitting) return;

        this.setState({ isSubmitting: true });

        if (!this.validateSection(activeStep)) {
            this.setState({ isSubmitting: false })
            return;
        }

        gsap.to(this.submitBtnRef, {
            opacity: 0.7,
            duration: 0.6,
            ease: `power2.out`
        });

        if (activeStep === 6) {
            const body = {
                tran: 1,
                idsolicitudvacante: this.state.idsolicitudvacante,
                codenteraste: this.state.selecinfoadi,
                declaraveracidad: this.state.toggleveracidad ? 1 : 0,
                descripcion: this.state.descenteraste.toUpperCase(),

            };
            InsertInfoAdicional(body).then(result => {
                if (result[0].code !== "000000") {
                    Swal.fire({ icon: 'error', title: 'Error', text: result[0].desc });
                } else {
                    const request = {
                        tran: 2,
                        idsolicitudvacante: this.state.idsolicitudvacante,
                        aceptapoli: this.state.chkTerminos ? 1 : 0
                    }
                    ActualizarEstadoHojaVida(request).then(result => {
                        if (result[0].code !== "000000") {
                            Swal.fire({ icon: 'error', title: 'Error', text: 'Error terminando de enviar solicitud.' });
                        } else {
                            this.animateSubmit();
                        }
                    }).catch(err => {
                        Swal.fire({ icon: 'error', title: 'Error', text: 'Error actualizando estado de la solicitud.' });
                    });
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo enviar la sección de referencia.' });
            });
        }
    }

    handleToggleClick = (val) => {
        const inputRef = this.fechaRetiroEmpleoRef?.current;

        if (val) {
            const today = new Date().toISOString().split('T')[0];
            this.setState({ isActual: true, fecRetEmpre1: today }, () => {
                this.textInput({ target: { name: 'fecRetEmpre1', value: today } });
                if (inputRef) gsap.set(inputRef, { pointerEvents: 'none', opacity: 0.4 });
            });
        } else {
            this.setState({ isActual: false, fecRetEmpre1: "", duracionEmpre1: "" }, () => {
                this.textInput({ target: { name: 'fecRetEmpre1', value: '' } });
                if (inputRef) gsap.set(inputRef, { pointerEvents: 'auto', opacity: 1 });
            });
        }
    }

    handleToggleChangeInfo = (val) => {
        this.setState({ toggleinfoper: val });
    }

    handleToggleChangeGrad = (val) => {
        this.setState({ togglegraduado: val });
        const inputAnioRef = this.anioTerminacionRef?.current;
        const inputSemesRef = this.numSemestreRef?.current;
        if (val) {
            this.setState({ togglegraduado: true, numsemestre: 0, anioterminacion: '' }, () => {
                this.textInput({ target: { name: 'numsemestre', value: '' } });
                this.textInput({ target: { name: 'anioterminacion', value: '' } });
                if (inputSemesRef) gsap.set(inputSemesRef, { pointerEvents: 'none', opacity: 0.4 });
                if (inputAnioRef) gsap.set(inputAnioRef, { pointerEvents: 'auto', opacity: 1 });
            });


        } else {
            this.setState({ togglegraduado: false, numsemestre: 0, anioterminacion: '' }, () => {
                this.textInput({ target: { name: 'numsemestre', value: '' } });
                this.textInput({ target: { name: 'anioterminacion', value: '' } });
                if (inputSemesRef) gsap.set(inputSemesRef, { pointerEvents: 'auto', opacity: 1 });
                if (inputAnioRef) gsap.set(inputAnioRef, { pointerEvents: 'none', opacity: 0.4 });
            });
        }
    }

    handleToggleChangeVera = (val) => {
        this.setState({ toggleveracidad: val });
    }

    handleCiudadChange = (selectedOption, { name, action }) => {
        if (action === 'clear') {
            switch (name) {
                case 'pais':
                case 'paisContacto':
                case 'paisEmpre':
                    if (name === 'pais') {
                        this.setState({
                            pais: null,
                            dpto: null,
                            dptos: [],
                            mpio: null,
                            mpios: [],
                            errors: {
                                ...this.state.errors,
                                pais: 'Debe seleccionar un país',
                                dpto: '',
                                mpio: ''
                            }
                        });
                    } else if (name === 'paisContacto') {
                        this.setState({
                            paisContacto: null,
                            dptoContacto: null,
                            dptos: [],
                            mpioContacto: null,
                            mpios: [],
                            errors: {
                                ...this.state.errors,
                                paisContacto: 'Debe seleccionar un país',
                                dptoContacto: '',
                                mpioContacto: ''
                            }
                        });
                    } else if (name === 'paisEmpre') {
                        this.setState({
                            paisEmpre: null,
                            dptoEmpre1: null,
                            mpioEmpre1: null,
                            dptos: [],
                            mpios: [],
                            errors: {
                                ...this.state.errors,
                                paisEmpre: 'Debe seleccionar un país',
                                dptoEmpre1: '',
                                mpioEmpre1: ''
                            }
                        });
                    }
                    break;
                case 'dpto':
                case 'dptoContacto':
                case 'dptoEmpre1':
                    if (name === 'dpto') {
                        this.setState({
                            dpto: null,
                            mpio: null,
                            mpios: [],
                            errors: {
                                ...this.state.errors,
                                dpto: 'Debe seleccionar un departamento',
                                mpio: ''
                            }
                        });
                    } else if (name === 'dptoContacto') {
                        this.setState({
                            dptoContacto: null,
                            mpioContacto: null,
                            mpios: [],
                            errors: {
                                ...this.state.errors,
                                dptoContacto: 'Debe seleccionar un departamento',
                                mpioContacto: ''
                            }
                        });
                    } else if (name === 'dptoEmpre1') {
                        this.setState({
                            dptoEmpre1: null,
                            mpioEmpre1: null,
                            mpios: [],
                            errors: {
                                ...this.state.errors,
                                dptoEmpre1: 'Debe seleccionar un departamento',
                                mpioEmpre1: ''
                            }
                        });
                    }
                    break;
                case 'mpio':
                case 'mpioContacto':
                case 'mpioEmpre1':
                    if (name === 'mpio') {
                        this.setState({
                            mpio: null,
                            errors: {
                                ...this.state.errors,
                                mpio: 'Debe seleccionar una ciudad'
                            }
                        });
                    } else if (name === 'mpioContacto') {
                        this.setState({
                            mpioContacto: null,
                            errors: {
                                ...this.state.errors,
                                mpioContacto: 'Debe seleccionar una ciudad'
                            }
                        });
                    } else if (name === 'mpioEmpre1') {
                        this.setState({
                            mpioEmpre1: null,
                            errors: {
                                ...this.state.errors,
                                mpioEmpre1: 'Debe seleccionar una ciudad'
                            }
                        });
                    }
                    break;
                default:
            }
            return;
        }
        this.setState(prevState => ({
            [name]: selectedOption,
            errors: {
                ...prevState.errors,
                [name]: selectedOption ? '' : `Debe seleccionar un ${name}`
            }
        }), () => {
            let filtroDpto = '', filtroMpio = '';
            if (action === 'select-option') {
                if (name === 'pais' || name === 'paisContacto' || name === 'paisEmpre') {
                    filtroDpto = name === 'pais' ? 'dpto' : name === 'paisEmpre' ? 'dptoEmpre1' : 'dptoContacto';
                    this.ConsultaPaises(filtroDpto, selectedOption.value);
                } else if (name === 'dpto' || name === 'dptoContacto' || name === 'dptoEmpre1') {
                    filtroMpio = name === 'dpto' ? 'mpio' : name === 'dptoEmpre1' ? 'mpioEmpre1' : 'mpioContacto';
                    this.ConsultaPaises(filtroMpio, selectedOption.value);
                }
            }
        });
    };


    GlobalHandleAddArray = (inputName, arrayName) => {
        const value = this.state[inputName].trim();
        const array = this.state[arrayName];
        if (value !== "") {
            this.setState({
                [arrayName]: [...array, value.toUpperCase()],
                [inputName]: "",
            });
        }

    }

    GlobalHandleAddObjectArray = (stateKey, arrayKey) => {
        this.setState(prev => ({
            [arrayKey]: [
                ...prev[arrayKey],
                {
                    formacion: prev.formAcadem,
                    graduado: prev.togglegraduado ? 1 : 0,
                    anioterminacion: prev.anioterminacion,
                    numsemestre: prev.numsemestre
                }
            ],

            formAcadem: "",
            anioterminacion: "",
            numsemestre: ""
        }));
    };

    GlobalHandleDeleteRow = (indexToDelete, arrayName) => {

        const updatedItem = this.state[arrayName].filter(
            (_, index) => index !== indexToDelete
        );
        this.setState({ [arrayName]: updatedItem });
    };

    tenureCalculation = (inicio, fin) => {
        const start = new Date(inicio);
        const end = new Date(fin);

        if (isNaN(start) || isNaN(end)) return "";

        let years = end.getFullYear() - start.getFullYear();
        let months = end.getMonth() - start.getMonth();
        let days = end.getDate() - start.getDate();
        if (days < 0) {
            months--;
            const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0); //último mes previo (meses de 0 a 11)
            days += prevMonth.getDate();
        }
        if (months < 0) {
            years--;
            months += 12;
        }
        const partes = [];
        if (years > 0) partes.push(`${years} año${years > 1 ? "s" : ""}`);
        if (months > 0) partes.push(`${months} mes${months > 1 ? "es" : ""}`);
        if (days > 0) partes.push(`${days} día${days > 1 ? "s" : ""}`);

        if (partes.length === 0) return "0 días";
        if (partes.length === 1) return partes[0];
        if (partes.length === 2) return partes.join(" y ");
        return partes.slice(0, -1).join(", ") + " y " + partes.slice(-1);

    }

    capitalizeWords = (str = '') => {
        return String(str)
            .toLocaleLowerCase('es-ES')
            .split(/(\s+)/) // mantiene separadores en el array
            .map(token => {
                if (token.trim() === '') return token; // es un espacio/separador
                return token.charAt(0).toLocaleUpperCase('es-ES') + token.slice(1);
            })
            .join('');
    };

    //MC - REPORT.PROSPECTOS, JUAN MELENDEZ 2026
    getSeccionContenido = () => {
        const { activeStep, errors, dataEscolaridad, dataInfoAdi } = this.state;

        switch (activeStep) {
            case 0:
                return (
                    <div className="container-fluid px-5 py-5 whitecard-conozcanos">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Primer Nombre <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="priNombre"
                                    ref={this.inputsRefs.priNombre}
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa tu primer nombre."
                                    value={this.state.priNombre}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.priNombre && (
                                    <small className="text-danger position-absolute" style={{ top: '75px' }}>
                                        {errors.priNombre}
                                    </small>
                                )}
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Segundo Nombre
                                </label>
                                <MDBInput
                                    name="segNombre"
                                    ref={this.inputsRefs.segNombre}
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa tu segundo nombre."
                                    value={this.state.segNombre}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Primer Apellido <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="priApellido"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa tu primer apellido."
                                    value={this.state.priApellido}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.priApellido && (
                                    <small className="text-danger position-absolute" style={{ top: '75px' }}>
                                        {errors.priApellido}
                                    </small>
                                )}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Segundo Apellido
                                </label>
                                <MDBInput
                                    name="segApellido"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa tu segundo apellido."
                                    value={this.state.segApellido}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                            </div>

                            <div id={`${errors.sexo ? "sexo-select" : ""}`} className="col-12 col-md-4">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Sexo <span className="text-danger">*</span>
                                </label>
                                <Select
                                    className="react-select-container"
                                    name="sexo"
                                    ref={this.selectRefs.sexo}
                                    options={generoOptions}
                                    styles={getCustomSelectStyles()}
                                    value={generoOptions.find(opt => opt.value === this.state.sexo) || null}
                                    onChange={selected => this.setState({ sexo: selected ? selected.value : 'DEFAULT' })}
                                    placeholder="Seleccione…"
                                    isClearable
                                />
                                {errors.sexo && <small className="text-danger">{errors.sexo}</small>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-3">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Tipo de Documento <span className="text-danger">*</span>
                                </label>
                                <Select
                                    className="react-select-container"
                                    name="tipoiden"
                                    ref={this.selectRefs.tipoiden}
                                    options={tipoIdenOptions}
                                    styles={getCustomSelectStyles()}
                                    value={tipoIdenOptions.find(opt => opt.value === this.state.tipoiden) || null}
                                    onChange={selected => this.setState({ tipoiden: selected ? selected.value : 'DEFAULT', nit: '' })}
                                    placeholder="Seleccione…"
                                    isClearable
                                />
                                {errors.tipoiden && <small className="text-danger">{errors.tipoiden}</small>}
                            </div>

                            <div className="col-12 col-md-5">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    No. Documento <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="nit"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa tu número de documento."
                                    value={this.state.nit}
                                    maxLength="20"
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.nit && (
                                    <small className="text-danger position-absolute" style={{ top: '75px' }}>
                                        {errors.nit}
                                    </small>
                                )}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Fecha de Expedición <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="fecExpe"
                                    type="date"
                                    className="text-postulate date-selector"
                                    value={this.state.fecExpe}
                                    onChange={this.textInput}
                                />
                                {errors.fecExpe && (
                                    <small className="text-danger position-absolute" style={{ top: '75px' }}>
                                        {errors.fecExpe}
                                    </small>
                                )}
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-12 col-md-8">
                                <label className="title-label form-label d-block fw-bold mb-1">
                                    Correo Electrónico <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="correo"
                                    type="email"
                                    className="text-postulate"
                                    label="Ingresa tu correo electrónico."
                                    value={this.state.correo}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.correo && (
                                    <small className="text-danger position-absolute" style={{ top: '75px' }}>
                                        {errors.correo}
                                    </small>
                                )}

                            </div>
                            <div className="col-12 col-md-4">
                                <label className="title-label form-label d-block fw-bold mb-1" style={{ width: '120%' }}>
                                    Fecha de Nacimiento <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="fecNac"
                                    type="date"
                                    className="text-postulate date-selector"
                                    value={this.state.fecNac}
                                    onChange={this.textInput}
                                />
                                {errors.fecNac && (
                                    <small className="text-danger position-absolute" style={{ top: '75px' }}>
                                        {errors.fecNac}
                                    </small>
                                )}
                            </div>


                        </div>
                    </div>

                );
            case 1:
                return (
                    <div className="container-fluid px-5 py-5 whitecard-conozcanos">
                        <div className="row">
                            <div className="col-md-4">
                                <p className="title-label form-label d-block fw-bold mb-1">
                                    Nivel Académico <b className="text-danger">*</b>
                                </p>
                                <Select
                                    name="escolaridad"
                                    options={dataEscolaridad}
                                    styles={getCustomSelectStyles()}
                                    value={dataEscolaridad.find(o => o.value === this.state.escolaridad) || null}
                                    onChange={selected => this.setState({ escolaridad: selected ? selected.value : 'DEFAULT' })}
                                    placeholder="Seleccione…"
                                    isClearable
                                />
                                {errors?.escolaridad && (
                                    <strong className="text-danger" style={{ fontSize: '13px' }}>
                                        {errors.escolaridad}
                                    </strong>
                                )}
                            </div>
                            <div className="col-md-4">
                                <p className="title-label form-label d-block fw-bold mb-1">Cargo Aspirado</p>
                                <MDBInput
                                    name="cargoAspira"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    disabled
                                    value={this.state.nombcargo}
                                    label="Este campo es autocompletado.*"
                                    autoComplete="off" />
                            </div>
                            <div className="col-md-4">
                                <p className="title-label form-label d-block fw-bold mb-1">
                                    Estado Civil <b className="text-danger">*</b>
                                </p>
                                <Select
                                    name="estadoCivil"
                                    styles={getCustomSelectStyles()}
                                    options={this.state.dataEstCivil}
                                    value={this.state.dataEstCivil.find(o => o.value === this.state.estadoCivil) || null}
                                    onChange={selected => this.setState({ estadoCivil: selected ? selected.value : 'DEFAULT' })}
                                    placeholder="Seleccione…"
                                    isClearable
                                />
                                {errors.estadoCivil && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.estadoCivil}</strong>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <p className="title-label form-label d-block fw-bold mb-1">País de Nacimiento <b className="text-danger">*</b></p>
                                <Select
                                    styles={getCustomSelectStyles()}
                                    name="pais"
                                    options={this.state.paises.filter(p => p.value !== 1)}
                                    onChange={this.handleCiudadChange}
                                    value={this.state.pais}
                                    placeholder="Seleccione..."
                                    isSearchable
                                    isClearable
                                />
                                {errors.pais && (<strong className="text-danger" style={{ fontSize: '13px' }}>{errors.pais}</strong>)}
                            </div>
                            <div className="col-md-4">
                                <p className="title-label form-label d-block fw-bold mb-1">Departamento de Nacimiento <b className="text-danger">*</b></p>
                                <Select
                                    styles={getCustomSelectStyles()}
                                    name="dpto"
                                    options={this.state.dptos}
                                    onChange={this.handleCiudadChange}
                                    value={this.state.dpto}
                                    placeholder="Seleccione..."
                                    isSearchable={true}
                                    isClearable={true}
                                    isDisabled={!this.state.pais}
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    menuPosition="fixed"
                                />
                                {errors.dpto && (<strong className="text-danger" style={{ fontSize: '13px' }}>{errors.dpto}</strong>)}
                            </div>
                            <div className="col-md-4">
                                <p className="title-label form-label d-block fw-bold mb-1">Ciudad de Nacimiento <b className="text-danger">*</b></p>
                                <Select
                                    styles={getCustomSelectStyles()}
                                    name="mpio"
                                    options={this.state.mpios}
                                    onChange={this.handleCiudadChange}
                                    value={this.state.mpio}
                                    placeholder="Seleccione..."
                                    isSearchable={true}
                                    isClearable={true}
                                    isDisabled={!this.state.dpto}
                                />
                                {errors.mpio && (<strong className="text-danger" style={{ fontSize: '13px' }}>{errors.mpio}</strong>)}
                            </div>
                        </div>

                        <div className={`row ${this.state.isMobile ? "" : "pt-4"}`}>
                            <div className="col-md-12 d-flex align-items-start">
                                <label className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="chkTrabaja"
                                        checked={this.state.chkTrabaja}
                                        onChange={() => this.setState({ chkTrabaja: !this.state.chkTrabaja })}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                &nbsp;<span className="form-label d-block mb-1">Has trabajado con nosotros</span>
                                {errors.chkTrabaja && (
                                    <strong className="text-danger" style={{ fontSize: '13px' }}>
                                        {errors.chkTrabaja}
                                    </strong>
                                )}
                            </div>
                        </div>

                        <div id="toggle-span-container" className={`row ${this.state.isMobile ? "pt-2" : "pt-5"}`} style={{ marginBottom: `${this.state.isMobile ? "" : "-6px"}` }}>
                            <div className={`${this.state.isMobile ? "col-md-12" : "col-md-8"}`}>
                                <p className="title-label form-label d-block fw-bold mb-1">
                                    ¿Tiene Vehículo Propio – Motocicleta? <b className="text-danger">*</b>
                                </p>
                                <ToggleSwitch
                                    label="Tengo vehiculo?"
                                    initialValue={this.state.toggleinfoper}
                                    onChange={this.handleToggleChangeInfo}
                                />
                                <span className="toggle-label-subtitle row pl-2">*Al marcar esta opción, declaro que soy propietario de vehículo motocicleta.</span>
                                <span className="toggle-label-subtitle row pl-2">Nota: El vehículo debe tener documentos al día.</span>
                            </div>
                        </div>
                    </div>

                );
            case 2:
                return (
                    <div className="container-fluid px-5 py-5 whitecard-conozcanos">

                        <div className="row g-3">
                            <div className="col-12 col-sm-5 col-md-3">
                                <label className="title-label mb-1">País de Residencia &nbsp;<b className="text-danger">*</b></label>
                                <Select
                                    name="paisContacto"
                                    options={this.state.paises.filter(p => p.value !== 1)}
                                    value={this.state.paisContacto}
                                    onChange={this.handleCiudadChange}
                                    placeholder="Seleccione..."
                                    isClearable
                                    className="select-alt select-country"
                                    classNamePrefix="select-country"
                                    styles={getCustomSelectStyles()}
                                />
                                {errors.paisContacto && (
                                    <small className="text-danger d-block" style={{ fontSize: 13 }}>
                                        {errors.paisContacto}
                                    </small>
                                )}
                            </div>

                            <div className="col-12 col-sm-7 col-md-4">
                                <label className="title-label mb-1">Departamento de Residencia <b className="text-danger">*</b></label>
                                <Select
                                    name="dptoContacto"
                                    options={this.state.dptos}
                                    value={this.state.dptoContacto}
                                    onChange={this.handleCiudadChange}
                                    placeholder="Seleccione..."
                                    isClearable
                                    className="select-alt"
                                    classNamePrefix="select-alt"
                                    styles={getCustomSelectStyles()}
                                    isDisabled={!this.state.paisContacto}
                                />
                                {errors.dptoContacto && <small className="text-danger d-block" style={{ fontSize: 13 }}>{errors.dptoContacto}</small>}
                            </div>

                            <div className="col-12 col-sm-12 col-md-5">
                                <label className="title-label mb-1">Ciudad de Residencia <b className="text-danger">*</b></label>
                                <Select
                                    name="mpioContacto"
                                    options={this.state.mpios}
                                    value={this.state.mpioContacto}
                                    onChange={this.handleCiudadChange}
                                    placeholder="Seleccione..."
                                    isClearable
                                    className="select-alt"
                                    classNamePrefix="select-alt"
                                    styles={getCustomSelectStyles()}
                                    isDisabled={!this.state.dptoContacto}
                                />
                                {errors.mpioContacto && <small className="text-danger d-block" style={{ fontSize: 13 }}>{errors.mpioContacto}</small>}
                            </div>
                        </div>

                        <div className={`row ${this.state.isMobile ? "" : "pt-5"}`}>
                            <div className="col-md-6">
                                <p className="title-label form-label d-block fw-bold mb-1">Dirección de Residencia <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="dirRes"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa tu dirección de residencia."
                                    value={this.state.dirRes}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.dirRes && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.dirRes}</strong>}
                            </div>
                            <div className="col-md-6">
                                <p className="title-label form-label d-block fw-bold mb-1">Barrio <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="barrio"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa el nombre de tu barrio."
                                    value={this.state.barrio}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.barrio && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.barrio}</strong>}
                            </div>

                        </div>


                        <div className="row">
                            <div className="col-md-12 align-items-start">
                                <label className="custom-checkbox" style={{ marginBottom: '3px' }}>
                                    <input
                                        type="checkbox"
                                        id="chkMpio"
                                        checked={this.state.chkMpio}
                                        onChange={() => this.handleCheckBox("chkMpio", "mpioLabora")}
                                    />
                                    <span id="dispo" className="checkmark"></span>
                                </label>
                                &nbsp;<span className="form-label">Disponibilidad para laborar en otro municipio</span>
                                {errors.chkMpio && (
                                    <strong className="text-danger" style={{ fontSize: '13px' }}>
                                        {errors.chkMpio}
                                    </strong>
                                )}
                            </div>

                        </div>
                        <div className="row pt-4">
                            <div className="col-md-6">
                                <p className="title-label form-label d-block fw-bold mb-1">¿Cuál?</p>
                                <MDBInput
                                    name="mpioLabora"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Municipio."
                                    value={this.state.mpioLabora}
                                    onChange={this.textInput}
                                    disabled={!this.state.chkMpio}
                                    autoComplete="off"
                                />
                                {errors.mpioLabora && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.mpioLabora}</strong>}
                            </div>
                            <div className="col-md-6">
                                <p className="title-label form-label d-block fw-bold mb-1">Número de Teléfono <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="celular"
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="(3[0-9]{9}|60[0-9]8[0-9]{6})"
                                    minLength={10}
                                    maxLength={10}
                                    className="mt-0 text-postulate"
                                    label="Ej: 3001234567 - (60X)8XXXXXX"
                                    value={this.state.celular}
                                    onChange={this.textInput}
                                    onBlur={this.validateCelular}
                                    onPaste={(e) => {
                                        const paste = (e.clipboardData || window.clipboardData).getData('text');
                                        if (/\D/.test(paste)) {
                                            e.preventDefault();
                                            const digits = paste.replace(/\D/g, '').slice(0, 10);
                                            this.setState({ celular: digits });
                                        }
                                    }}
                                    required
                                    autoComplete="off"
                                />
                                {errors.celular && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.celular}</strong>}
                            </div>
                        </div>


                    </div>
                );
            case 3:
                return (
                    <div className="container-fluid px-5 py-5 whitecard-conozcanos">
                        <div className="row align-items-center">
                            {/*AJUSTE PARA RQTO HOJA DE VIDA PAGINA WEB JUANPAGM - 2025/00/00*/}
                            <div className="col" style={{ marginBottom: `${errors.formAcadem ? '12px' : '0'}` }}>
                                <p className="title-label form-label d-block fw-bold mb-1">Formación Académica <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="formAcadem"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa tu formación académica."
                                    value={this.state.formAcadem}
                                    onChange={(e) => {
                                        this.textInput(e);

                                        const errorObj = this.validateMinLenght(e.target.value, "formAcadem", 4);
                                        this.setState(prev => ({
                                            errors: {
                                                ...prev.errors,
                                                formAcadem: errorObj.formAcadem || "",
                                            },
                                        }));
                                    }}
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            const errorObj = this.validateMinLenght(this.state.formAcadem, "formAcadem", 4);
                                            if (errorObj.formAcadem) {
                                                this.setState((prev) => ({
                                                    errors: { ...prev.errors, formAcadem: errorObj.formAcadem },
                                                }));
                                            } else {
                                                this.GlobalHandleAddObjectArray("formAcadem", "formAcademica");
                                                this.setState((prev) => ({
                                                    errors: { ...prev.errors, formAcadem: "" },
                                                }));
                                            }
                                        }
                                    }}
                                />
                                {errors.formAcadem && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.formAcadem}</strong>}
                            </div>
                            <div id="toggle-span-container" className={`col-md-auto d-flex ${this.state.isMobile ? "pt-2" : ""}`} style={{ marginBottom: `${this.state.isMobile ? "20px" : "50px"}` }}>
                                <div className="col pl-0">
                                    <p className="title-label form-label d-block fw-bold mb-4">
                                        Graduado<b className="text-danger">*</b>
                                    </p>
                                    <ToggleSwitch
                                        label="Estoy graduado?"
                                        initialValue={this.state.togglegraduado}
                                        onChange={this.handleToggleChangeGrad}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                this.GlobalHandleAddObjectArray("togglegraduado", "togglegraduado");
                                                this.setState((prev) => ({
                                                    errors: { ...prev.errors, togglegraduado: "" },
                                                }))
                                            }
                                        }}
                                    />
                                    <span className="toggle-label-subtitle">*Al marcar esta opción, declaro que he terminado mi formación académica.</span>
                                </div>
                            </div>
                            {/*FIN*/}
                        </div>
                        {/*DAVID*/}
                        <div className="row" >
                            <div ref={this.anioTerminacionRef} className="col" style={{ marginBottom: `${errors.anioterminacion ? '12px' : '0'}`, opacity: 0.4 }}>
                                <p className="title-label form-label d-block fw-bold mb-1">Año de terminación <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="anioterminacion"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa el año de terminación."
                                    pattern="(19[0-9]{2}|20[0-9]{2})"
                                    minLength={4}
                                    maxLength={4}
                                    value={this.state.anioterminacion}
                                    disabled={!this.state.togglegraduado}
                                    onChange={(e) => {
                                        this.textInput(e);

                                        const errorObj = this.validateMinLenght(e.target.value, "anioterminacion", 4);
                                        this.setState(prev => ({
                                            errors: {
                                                ...prev.errors,
                                                anioterminacion: errorObj.anioterminacion || "",
                                            },
                                        }));
                                    }}
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            const errorObj = this.validateMinLenght(this.state.anioterminacion, "anioterminacion", 4);
                                            if (errorObj.anioterminacion) {
                                                this.setState((prev) => ({
                                                    errors: { ...prev.errors, anioterminacion: errorObj.anioterminacion },
                                                }));
                                            } else {
                                                this.GlobalHandleAddObjectArray("anioterminacion", "anioterminacion");
                                                this.setState((prev) => ({
                                                    errors: { ...prev.errors, anioterminacion: "" },
                                                }));
                                            }
                                        }
                                    }}
                                />
                                {errors.anioterminacion && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.anioterminacion}</strong>}
                            </div>
                            <div ref={this.numSemestreRef} className="col" style={{ marginBottom: `${errors.numsemestre ? '12px' : '0'}` }}>
                                <p className="title-label form-label d-block fw-bold mb-1">Numero de semestres cursados <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="numsemestre"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa el numero de semestres cursados."
                                    pattern="([1-9]|1[0-5])"
                                    minLength={1}
                                    maxLength={2}
                                    value={this.state.numsemestre}
                                    disabled={this.state.togglegraduado}
                                    onChange={(e) => {
                                        this.textInput(e);

                                        const errorObj = this.validateMinLenght(e.target.value, "numsemestre", 1);
                                        this.setState(prev => ({
                                            errors: {
                                                ...prev.errors,
                                                numsemestre: errorObj.numsemestre || "",
                                            },
                                        }));
                                    }}
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            const errorObj = this.validateMinLenght(this.state.numsemestre, "numsemestre", 2);
                                            if (errorObj.numsemestre) {
                                                this.setState((prev) => ({
                                                    errors: { ...prev.errors, numsemestre: errorObj.numsemestre },
                                                }));
                                            } else {
                                                this.GlobalHandleAddObjectArray("numsemestre", "numsemestre");
                                                this.setState((prev) => ({
                                                    errors: { ...prev.errors, numsemestre: "" },
                                                }));
                                            }
                                        }
                                    }}
                                />
                                {errors.numsemestre && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.numsemestre}</strong>}
                            </div>
                            <div className="col-md-auto d-flex align-items-center justify-content-start add-btn">
                                <button
                                    id={"btnAddFormacion"}
                                    className={`btn-circle mb-1 ${this.state.errors.formAcadem ? "error-appeared" : "none-error"}`}
                                    style={{ opacity: `${this.state.errors.formAcadem ? '0.2' : '1'}` }}
                                    disabled={!!this.state.errors.formAcadem}
                                    onMouseEnter={this.onBTNMouseEnter}
                                    onMouseMove={this.onBTNMouseMove}
                                    onMouseLeave={this.onBTNMouseLeave}
                                    onClick={() => {
                                        const errorObj = this.validateMinLenght(this.state.formAcadem, "formAcadem", 4);
                                        if (errorObj.formAcadem) {
                                            this.setState((prev) => ({
                                                errors: { ...prev.errors, formAcadem: errorObj.formAcadem },
                                            }));
                                        } else {
                                            this.GlobalHandleAddObjectArray("formAcadem", "formAcademica");
                                            this.setState((prev) => ({
                                                errors: { ...prev.errors, formAcadem: "" },
                                            }));
                                        }
                                    }}
                                >
                                    <span className="btn-text conozcanos"></span>
                                    <span className="hover-bubble" />
                                </button>
                            </div>
                        </div>
                        {/*DAVID*/}
                        {/*MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE AGREGA ADVERTENCIA PARA REGISTRAR FORMACION ACADEMICA*/}
                        <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '63%' }}>*Debes presionar el boton "+" para que se registre la formacion academica</strong>
                        <div className="row">
                            <div className="col-md-12" style={{ margin: 'auto' }}>
                                <table className="custom-table">
                                    <thead className="custom-head">
                                        <tr>
                                            <th style={{ width: '10%' }}>No.</th>
                                            <th >Estudios</th>
                                            {/*<th style={{ width: '14%' }}>Año de terminación</th>*/}
                                            {/*<th style={{ width: '14%' }}>No. semestre</th>*/}
                                            {/*<th style={{ width: '14%' }}>Graduado</th>*/}
                                            <th style={{ width: '14%' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: 'center' }}>
                                        {this.state.formAcademica.length > 0 ? (
                                            this.state.formAcademica.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index = index + 1}</td>
                                                    <td>{item.formacion}</td>
                                                    {/*<td>{item.anioterminacion}</td>*/}
                                                    {/*<td>{item.numsemestre}</td>*/}
                                                    {/*<td>{item.graduado === 1 ? "Sí" : "No"}</td>*/}
                                                    <td>
                                                        <button
                                                            id={"btnDeleteFormacion"}
                                                            className="btn-icon"
                                                            onClick={() => this.GlobalHandleDeleteRow(index - 1, "formAcademica")}
                                                        >
                                                            <MDBIcon icon="trash-alt" className="fa-lg" style={{ color: '#f57c00' }} />
                                                        </button>

                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center text-muted" style={{ padding: '8px 8px 1px' }}>
                                                    No hay registros de formación académica agregados
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                );
            case 4:
                return (
                    <div className="container-fluid px-5 py-5 whitecard-conozcanos">

                        <div className="row">
                            <div className="col-md-7">
                                <label className="font-weight-bold mb-0 pb-0">
                                    Nombre de la empresa No. {(this.state.experienciasLaborales?.length || 0) + 1} <b className="text-danger">*</b>
                                </label>
                                <MDBInput
                                    name="nomEmpre"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa el nombre de la empresa."
                                    value={this.state.nomEmpre}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.nomEmpre && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.nomEmpre}</strong>}
                            </div>
                            <div className="col-md-5">
                                <p className="font-weight-bold mb-0 pb-0">Número de teléfono <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="telEmpre"
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="(3[0-9]{9}|60[0-9]8[0-9]{6})"
                                    minLength={10}
                                    maxLength={10}
                                    className="mt-0 text-postulate"
                                    label="Ej: 3001234567 - (60X)8XXXXXX"
                                    value={this.state.telEmpre}
                                    onChange={this.textInput}
                                    onPaste={(e) => {
                                        const paste = (e.clipboardData || window.clipboardData).getData('text');
                                        if (/\D/.test(paste)) {
                                            e.preventDefault();
                                            const digits = paste.replace(/\D/g, '').slice(0, 10);
                                            this.setState({ celular: digits });
                                        }
                                    }}
                                    required
                                    autoComplete="off"
                                />

                                {errors.telEmpre && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.telEmpre}</strong>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <p className="font-weight-bold mb-0 pb-0">País <b className="text-danger">*</b></p>
                                <Select
                                    name="paisEmpre"
                                    options={this.state.paises.filter(p => p.value !== 1)}
                                    onChange={this.handleCiudadChange}
                                    value={this.state.paisEmpre}
                                    placeholder="Seleccione..."
                                    isSearchable={true}
                                    isClearable={true}
                                    styles={getCustomSelectStyles()}
                                />
                                {this.state.errors.paisEmpre && (<strong className="text-danger" style={{ fontSize: '13px' }}>{this.state.errors.paisEmpre}</strong>)}
                            </div>
                            <div className="col-md-4">
                                <p className="font-weight-bold mb-0 pb-0">Departamento <b className="text-danger">*</b></p>
                                <Select
                                    name="dptoEmpre1"
                                    options={this.state.dptos}
                                    onChange={this.handleCiudadChange}
                                    value={this.state.dptoEmpre1}
                                    placeholder="Seleccione..."
                                    isSearchable={true}
                                    isClearable={true}
                                    isDisabled={!this.state.paisEmpre}
                                    styles={getCustomSelectStyles()}
                                />
                                {this.state.errors.dptoEmpre1 && (<strong className="text-danger" style={{ fontSize: '13px' }}>{this.state.errors.dptoEmpre1}</strong>)}
                            </div>
                            <div className="col-md-4">
                                <p className="font-weight-bold mb-0 pb-0">Ciudad <b className="text-danger">*</b></p>
                                <Select
                                    name="mpioEmpre1"
                                    options={this.state.mpios}
                                    onChange={this.handleCiudadChange}
                                    value={this.state.mpioEmpre1}
                                    placeholder="Seleccione..."
                                    isSearchable={true}
                                    isClearable={true}
                                    isDisabled={!this.state.dptoEmpre1}
                                    styles={getCustomSelectStyles()}
                                />
                                {this.state.errors.mpioEmpre1 && (<strong className="text-danger" style={{ fontSize: '13px' }}>{this.state.errors.mpioEmpre1}</strong>)}
                            </div>
                        </div>

                        <div id="toggle-span-container" className={`row ${this.state.isMobile ? "pt-2" : "pt-5"}`} style={{ marginBottom: `${this.state.isMobile ? "" : "-6px"}` }}>
                            <div className={`${this.state.isMobile ? "col-md-12" : "col-md-8"}`}>
                                <ToggleSwitch
                                    ref={this.tgSwitchEmpleoActualRef}
                                    label="Este es mi empleo actual."
                                    initialValue={this.state.isActual}
                                    onChange={this.handleToggleClick}
                                />
                                <span className="toggle-label-subtitle"> * Al marcar esta opción, declaras que este es tu empleo actual (sin fecha de retiro). Si posees terminación, puedes continuar sin esto e introducir la fecha.</span>
                                {/*<span className="toggle-label-subtitle">Al marcar esta opción declaras la presente experiencia como tu actual empleo y se desactiva la fecha de retiro. </span>*/}
                            </div>
                        </div>
    
                        {/*<div className={`row ${this.state.isMobile ? "" : "pt-5"}`}>*/}
                        <div className="row pt-5">
                            <div className="col-md-3">
                                <p className="font-weight-bold mb-0 pb-0">Cargo <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="cargoEmpre1"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa el nombre del cargo."
                                    value={this.state.cargoEmpre1}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.cargoEmpre1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.cargoEmpre1}</strong>}
                            </div>
                            <div className="col-md-3">
                                <p className="font-weight-bold mb-0 pb-0">Fecha de Ingreso <b className="text-danger">*</b></p>                               
                                <MDBInput
                                    name="fecIngEmpre1"
                                    type="date"
                                    className="mt-0 text-postulate"
                                    value={this.state.fecIngEmpre1}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.fecIngEmpre1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.fecIngEmpre1}</strong>}
                            </div>
                            <div ref={this.fechaRetiroEmpleoRef} className="col-md-3" style={{ transition: "all 0.5s ease-in-out" }}>
                                <p className="font-weight-bold mb-0 pb-0">Fecha de Retiro <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="fecRetEmpre1"
                                    type="date"
                                    className="mt-0 text-postulate"
                                    value={this.state.fecRetEmpre1}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                    disabled={this.state.isActual}
                                />
                                {errors.fecRetEmpre1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.fecRetEmpre1}</strong>}
                            </div>
                            <div className="col-md-3">
                                <p className="font-weight-bold mb-0 pb-0">Duración <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="duracionEmpre1"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Ingresa las fechas."
                                    disabled
                                    value={this.state.duracionEmpre1}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.duracionEmpre1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.duracionEmpre1}</strong>}
                            </div>
                        </div>

                        <div className="row align-items-center">
                            <div className="col-md-8">
                                <p className="title-label form-label d-block fw-bold mb-1">Funciones principales <b className="text-danger">*</b></p>
                                <MDBInput
                                    name="funcEmpre1"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Enlista una por una 5 funciones relacionadas con el cargo que desempeñaba."
                                    disabled={this.state.skills.length >= 5}
                                    value={this.state.funcEmpre1}
                                    onChange={(e) => {
                                        this.textInput(e);
                                        const errorObj = this.validateMinLenght(e.target.value, "funcEmpre1", 8);
                                        this.setState(prev => ({
                                            errors: {
                                                ...prev.errors,
                                                funcEmpre1: errorObj.funcEmpre1 || ""
                                            }
                                        }));
                                    }}
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && this.state.skills.length < 5) {
                                            e.preventDefault();
                                            const errorObj = this.validateMinLenght(this.state.funcEmpre1, "funcEmpre1", 8);
                                            if (errorObj.funcEmpre1) {
                                                this.setState(prev => ({
                                                    errors: {
                                                        ...prev.errors,
                                                        funcEmpre1: errorObj.funcEmpre1 || ""
                                                    }
                                                }));
                                            } else {
                                                this.GlobalHandleAddArray("funcEmpre1", "skills");
                                                this.setState(prev => ({
                                                    errors: {
                                                        ...prev.errors,
                                                        funcEmpre1: ""
                                                    }
                                                }));
                                            }                                            
                                        }
                                    }}
                                />

                                {errors.funcEmpre1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.funcEmpre1}</strong>}
                            </div>

                            <div className="col-md-2 d-flex align-items-center justify-content-start add-btn add-btn-funciones">
                                <button
                                    id={"btnAddSkills"}
                                    className={`btn-circle mb-1 ${this.state.skills.length >= 5 ? "hidden-btn" : "visible-btn"}`}
                                    style={{ opacity: `${this.state.errors.funcEmpre1 && this.state.skills.length <= 5 ? '0.2' : ''}` }}
                                    disabled={!!this.state.errors.funcEmpre1 || this.state.skills.length >= 5 }
                                    onMouseEnter={this.onBTNMouseEnter}
                                    onMouseMove={this.onBTNMouseMove}
                                    onMouseLeave={this.onBTNMouseLeave}
                                    onClick={() => {
                                        const errorObj = this.validateMinLenght(this.state.funcEmpre1, "funcEmpre1", 8);
                                        if (errorObj.funcEmpre1) {
                                            this.setState(prev => ({
                                                errors: { ...prev.errors, funcEmpre1: errorObj.funcEmpre1 }
                                            }));
                                        } else {
                                            this.GlobalHandleAddArray("funcEmpre1", "skills");
                                            this.setState(prev => ({
                                                errors: { ...prev.errors, funcEmpre1: "" },
                                            }));
                                        }            
                                    }}
                                >
                                    <span className="btn-text conozcanos"></span>
                                    <span className="hover-bubble" />
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12" style={{ margin: 'auto' }}>
                                {errors.skills && (
                                    <div style={{ marginBottom: '8px' }}>
                                        <strong className="text-danger" style={{ fontSize: '13px' }}>
                                            {errors.skills}
                                        </strong>
                                    </div>
                                )}
                                <table className="custom-table">
                                    <thead className="custom-head">
                                        <tr>
                                            <th style={{ width: '10%' }}>No.</th>
                                            <th >Funciones Principales</th>
                                            <th style={{ width: '14%' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: 'center' }}>
                                        {this.state.skills.length > 0 ? (
                                            this.state.skills.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item}</td>
                                                    <td>
                                                        <button
                                                            id={"btnDeleteSkills"}
                                                            className="btn-icon"
                                                            onClick={() => this.GlobalHandleDeleteRow(index, "skills")}
                                                        >
                                                            <MDBIcon icon="trash-alt" className="fa-lg" style={{ color: '#f57c00' }} />
                                                        </button>

                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center text-muted" style={{ padding: '8px 8px 1px' }}> No hay registros de funciones principales agregados </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </div>
                );
            case 5:
                return (
                    <div className="container-fluid px-5 py-5 whitecard-conozcanos">
                        <div className={`row ${this.state.isMobile ? "" : "mb-4"}`}>
                            <div className="col-12 col-md-6">
                                <label className="title-label form-label fw-bold mb-1">
                                    Primer Nombre Referencia Personal <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="perrefprinom"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa el primer nombre."
                                    value={this.state.perrefprinom}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.perrefprinom && (
                                    <small className="text-danger d-block mt-1">{errors.perrefprinom}</small>
                                )}
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="title-label form-label fw-bold mb-1">Segundo Nombre</label>
                                <MDBInput
                                    name="perrefsegnom"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa el segundo nombre."
                                    value={this.state.perrefsegnom}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                            </div>
                        </div>

                        <div className={`row ${this.state.isMobile ? "" : "mb-4"}`}>
                            <div className="col-12 col-md-4">
                                <label className="title-label form-label fw-bold mb-1">
                                    Primer Apellido Referencia Personal <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="perrefpriape"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa el primer apellido."
                                    value={this.state.perrefpriape}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.perrefpriape && (
                                    <small className="text-danger d-block mt-1">{errors.perrefpriape}</small>
                                )}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="title-label form-label fw-bold mb-1">Segundo Apellido</label>
                                <MDBInput
                                    name="perrefsegape"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa el segundo apellido."
                                    value={this.state.perrefsegape}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="title-label form-label fw-bold mb-1">
                                    Ocupación <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="perrefocupa"
                                    type="text"
                                    className="text-postulate"
                                    label="Ingresa su ocupación."
                                    value={this.state.perrefocupa}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.perrefocupa && (
                                    <small className="text-danger d-block mt-1">{errors.perrefocupa}</small>
                                )}
                            </div>
                        </div>

                        <div className="row">
                            <div className={`col-12 col-md-6 mb-md-0 ${this.state.isMobile ? "" : "mb-4"}`}>
                                <label className="title-label form-label fw-bold mb-1">
                                    Nombre de la Empresa <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="perrefempre"
                                    type="text"
                                    className="text-postulate company-name"
                                    label="Ingresa el nombre de la empresa."
                                    value={this.state.perrefempre}
                                    onChange={this.textInput}
                                    autoComplete="off"
                                />
                                {errors.perrefempre && (
                                    <small className="text-danger d-block mt-1 mb-4">{errors.perrefempre}</small>
                                )}
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="title-label form-label fw-bold mb-1">
                                    Número de Contacto <span className="text-danger">*</span>
                                </label>
                                <MDBInput
                                    name="perreftelcel"
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="(3[0-9]{9}|60[0-9]8[0-9]{6})"
                                    minLength={10}
                                    maxLength={10}
                                    className="text-postulate"
                                    label="Ingresa el teléfono de contacto. Ej: 3001234567 - (60X)8XXXXXX"
                                    value={this.state.perreftelcel}
                                    onChange={this.textInput}
                                    onPaste={(e) => {
                                        const paste = (e.clipboardData || window.clipboardData).getData('text');
                                        if (/\D/.test(paste)) {
                                            e.preventDefault();
                                            const digits = paste.replace(/\D/g, '').slice(0, 10);
                                            this.setState({ perreftelcel: digits });
                                        }
                                    }}
                                    autoComplete="off"
                                />
                                {errors.perreftelcel && (
                                    <small id="num-contac-error" className="text-danger d-block mt-1">{errors.perreftelcel}</small>
                                )}
                            </div>
                        </div>
                    </div>
                );
            case 6:
                return (
                    <div className="container-fluid px-5 py-5 whitecard-conozcanos">
                        <div className="row">
                            <div className="col-md-4">
                                <p className="title-label form-label d-block fw-bold mb-1">
                                    ¿Como te enteraste de nosotros? <b className="text-danger">*</b>
                                </p>
                                <Select
                                    name="selecinfoadi"
                                    options={dataInfoAdi}
                                    styles={getCustomSelectStyles()}
                                    value={dataInfoAdi.find(o => o.value === this.state.selecinfoadi) || null}
                                    onChange={selected => this.setState({ selecinfoadi: selected ? selected.value : 'DEFAULT' })}
                                    placeholder="Seleccione…"
                                    isClearable
                                />
                                {errors?.selecinfoadi && (
                                    <strong className="text-danger" style={{ fontSize: '13px' }}>
                                        {errors.selecinfoadi}
                                    </strong>
                                )}
                            </div>

                            <div className="col">
                                <p className="title-label form-label d-block fw-bold mb-1">Cual<b className="text-danger">*</b></p>
                                <MDBInput
                                    name="descenteraste"
                                    type="text"
                                    className="mt-0 text-postulate"
                                    label="Como te enteraste."
                                    value={this.state.selecinfoadi !== 5 ? "" : this.state.descenteraste}
                                    onChange={this.textInput}
                                    disabled={this.state.selecinfoadi !== 5}
                                    autoComplete="off"
                                />
                                {errors.descenteraste && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.descenteraste}</strong>}
                            </div>
                        </div>

                        <div id="toggle-span-container" className={`row ${this.state.isMobile ? "pt-2" : ""}`} style={{ marginBottom: `${this.state.isMobile ? "" : "-6px"}` }}>
                            <div className={`${this.state.isMobile ? "col-md-auto" : "col-md-auto"}`}>
                                <p className="title-label form-label d-block fw-bold mb-1">
                                    Declaración de veracidad de la información suministrada.
                                </p>
                                <p className="title-label form-label d-block fw-bold mb-1">
                                    Para todos los efectos legales, declaro que la información registrada y los datos suministrados por mí en este formulario son verídicos y corresponden a la realidad.
                                </p>
                                <ToggleSwitch
                                    label="* Al marcar esta opción, certifico la veracidad de la información suministrada."
                                    initialValue={this.state.toggleveracidad}
                                    onChange={this.handleToggleChangeVera}
                                />
                                <div className="col-12" style={{ marginTop: '10px' }}>
                                    {errors.toggleveracidad && (
                                        <strong className="text-danger" style={{ fontSize: '13px' }}>
                                            {errors.toggleveracidad}
                                        </strong>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 align-items-start mt-4" >
                                <label className="custom-checkbox" style={{ marginBottom: '3px' }}>
                                    <input
                                        type="checkbox"
                                        checked={this.state.chkTerminos}
                                        onChange={() => this.setState({ chkTerminos: !this.state.chkTerminos })}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                &nbsp;
                                <span className="form-label mb-1">
                                    He leído y acepto la{" "}
                                    <a
                                        href="https://www.utrahuilca.coop/AvisoPrivacidad"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "underline", color: "#f57c00", cursor: "pointer" }}
                                    >
                                        política de tratamiento de datos personales de la empresa.
                                    </a>
                                </span>
                            </div>
                            <div className="col-12" style={{ marginTop: '21px' }}>
                                {errors.chkTerminos && (
                                    <strong className="text-danger" style={{ fontSize: '13px' }}>
                                        {errors.chkTerminos}
                                    </strong>
                                )}
                            </div>
                        </div>

                    </div>

                );
            default:
                return null;
        }
    }
    render() {
        const { isMobile, activeStep } = this.state;
        const isLastStep = activeStep === this.state.data.length - 1;

        return (
            <React.Fragment>
                <div id="seccioncvRoot" className="container" style={{ touchAction: 'manipulation', paddingBottom: '3%', transition: 'all 0.3s ease-in-out' }}>
                    <div className="intro-container" ref={(ref) => (this.titleRef = ref)}>
                        <div
                            ref={(ref) => (this.textContainerRef = ref)}
                            className="intro-text-wrapper"
                        >
                            <h2
                                ref={(ref) => (this.textRef = ref)}
                                className="intro-text"
                            >
                                Despeg
                            </h2>
                        </div>
                        <img
                            ref={(ref) => (this.planeRef = ref)}
                            className="intro-svg"
                            src={`${URLImgFront}/assets/img-variadas/paper_plane_utrahuilca-background.svg`}
                            alt='plane'
                        />
                    </div>
                    {!isMobile ? (
                        <div className="progress-bar-container" ref={(ref) => this.barContainerRef = ref}>
                            <div className="progress-line-background">
                                <div className="progress-line-fill" ref={(ref) => (this.lineRef = ref)}></div>
                                <div className="progress-dot start" ref={(ref) => (this.dotStartRef = ref)}></div>
                                <div className="progress-dot end" ref={(ref) => (this.dotEndRef = ref)}></div>
                            </div>
                            <div className="progress-steps" ref={(ref) => this.progressStepsRef = ref}>
                                {this.state.data.map((item, index) => {
                                    const { activeStep, isSubmitting } = this.state;
                                    const isActive = activeStep === index;
                                    const isCompleted = activeStep > index || isSubmitting;
                                    const isPreviousStep = activeStep - 1 === index;
                                    return (
                                        <div
                                            key={index}
                                            className={`progress-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isPreviousStep ? 'previous-step' : ''}`}
                                            ref={(ref) => (this[`stepRef${index}`] = ref)}
                                        >
                                            <div style={{ backgroundColor: '#f6f7f8', paddingInline: '3px' }}>
                                                <div className="circle">
                                                    {isCompleted ? (
                                                        <div className="lottie-wrapper">
                                                            <LottiePlayer
                                                                path={`${URLImgFront}/assets/img-variadas/step_completo_utrahuilca.json`}
                                                                loop={false}
                                                                speed={0.86}
                                                                autoplay={true}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <span className="label">{item.descseccion}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className="section-header" ref={(ref) => this.barContainerRef = ref}>
                            <h2 className="active-section-name">
                                {this.capitalizeWords(this.state.data[activeStep]?.descseccion)}
                            </h2>
                        </div>
                    )}

                    {!this.state.isFinalized ? (
                        <>
                            <div ref={(ref) => this.contentRef = ref}>
                                <div className="section-wrapper">
                                    <div className="section-inner" ref={this.sectionRef}>
                                        {this.getSeccionContenido()}
                                    </div>
                                </div>
                                {this.state.activeStep === 4 && this.state.experienciasLaborales.length > 0 && (
                                    <div className="experiencias-container">
                                        Tus experiencias:
                                        {this.state.experienciasLaborales.map((exp, index) => (
                                            <span key={exp.idexperiencialaboral || index} className="exp-tag">
                                                {exp.nomempresa}
                                                <button
                                                    className="btn-icon"
                                                    onClick={() => this.handleEliminarExperiencia(exp.idexperiencialaboral)}
                                                >
                                                    <MDBIcon icon="times" style={{ color: '#f57c00' }} />
                                                </button>
                                            </span>
                                        ))}
                                    </div>
                                )}
                      
                                <div className="button-container">
                                    {this.state.activeStep > 0 && (
                                        <button
                                            ref={ref => this.btnAnteriorRef = ref}
                                            className="btn-positive darken to-appear-btn"
                                            onMouseEnter={this.onBTNMouseEnter}
                                            onMouseMove={this.onBTNMouseMove}
                                            onMouseLeave={this.onBTNMouseLeave}
                                            onClick={this.handleBack}
                                        >
                                            <span className="btn-text">Anterior</span>
                                            <span className="hover-bubble" />
                                        </button>
                                    )}

                                    {isLastStep ? (
                                        <button
                                            ref={(ref) => this.submitBtnRef = ref}
                                            className="btn-positive to-appear-btn"
                                            onMouseEnter={this.onBTNMouseEnter}
                                            onMouseMove={this.onBTNMouseMove}
                                            onMouseLeave={this.onBTNMouseLeave}
                                            onClick={this.handleSubmit}
                                            disabled={this.state.isSubmitting || this.state.isFinalized}
                                        >
                                            <span className="btn-text">Enviar</span>
                                            <span className="hover-bubble" />
                                        </button>
                                    ) : (
                                        <>
                                            {this.state.activeStep !== 4 && (
                                                <button
                                                    ref={ref => this.btnSiguienteRef = ref}
                                                    className="btn-positive"
                                                    onClick={this.handleNext}
                                                    onMouseEnter={this.onBTNMouseEnter}
                                                    onMouseMove={this.onBTNMouseMove}
                                                    onMouseLeave={this.onBTNMouseLeave}
                                                >
                                                    <span className="btn-text">Siguiente</span>
                                                    <span className="hover-bubble" />
                                                </button>
                                            )}

                                            {this.state.activeStep === 4 && (
                                                <>
                                                    {this.isEmptyExperiencia() ? (
                                                        <button
                                                            ref={ref => this.btnSiguienteAltRef = ref}
                                                            className="btn-positive"
                                                            onClick={this.handleNext}
                                                            onMouseEnter={this.onBTNMouseEnter}
                                                            onMouseMove={this.onBTNMouseMove}
                                                            onMouseLeave={this.onBTNMouseLeave}
                                                        >
                                                            <span className="btn-text">Siguiente</span>
                                                            <span className="hover-bubble" />
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <button
                                                                ref={ ref => this.btnAgregarExpRef = ref }
                                                                className="btn-positive darken-alt"
                                                                onClick={this.handleAddExperiencia}
                                                                onMouseEnter={this.onBTNMouseEnter}
                                                                onMouseMove={this.onBTNMouseMove}
                                                                onMouseLeave={this.onBTNMouseLeave}
                                                            >
                                                                <span className="btn-text">Agregar experiencia</span>
                                                                <span className="hover-bubble" />
                                                            </button>
                                                           
                                                            {this.state.experienciasLaborales.length >= 2 && (
                                                                <button
                                                                    className="btn-positive"
                                                                    onClick={this.handleNext}
                                                                    onMouseEnter={this.onBTNMouseEnter}
                                                                    onMouseMove={this.onBTNMouseMove}
                                                                    onMouseLeave={this.onBTNMouseLeave}
                                                                >
                                                                    <span className="btn-text">Siguiente</span>
                                                                    <span className="hover-bubble" />
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </>

                    ) : (
                        <div className="container-panel px-3 px-md-5 pt-5 whitecard-conozcanos" ref={(ref) => (this.finalizedSeccion = ref)}>
                            <div className="rounded-3 main-container">
                                <div className="tab-content pt-3 titleFinal">
                                    <div id="DvMensResultado">
                                        <h1 className='mainTitle'>¡En<span>hora</span>buena!</h1>
                                        <img className='imgFinal' alt='cristalPc' src={`${URLImgFront}/assets/img-variadas/cristal/6.png`} />
                                        <h2 className='justify-content-center'>
                                            Se completó el proceso de validación y envío de tus datos exitosamente.
                                        </h2>
                                        <p className='text-align-center'>
                                            Tu postulación fue emitida al área correspondiente. Te contactaremos si tu perfil cumple los requisitos del cargo.
                                        </p>
                                    </div>
                                    <div className="mt-3" style={{ display: 'block' }}>
                                        <button
                                            className="btn-positive"
                                            onMouseEnter={this.onBTNMouseEnter}
                                            onMouseMove={this.onBTNMouseMove}
                                            onMouseLeave={this.onBTNMouseLeave}
                                            onClick={() => window.location.href = '/Trabaje_con_nosotros'}
                                        >
                                            <span className="btn-text">Aceptar</span>
                                            <span className="hover-bubble" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default SeccionCV;
